import update from 'immutability-helper';

const initialState = () => ({
    routes: [
        { path: '/users', component: 'UserActionBar' },
        { path: '/devices', component: 'DeviceActionBar' },
        { path: '/groups', component: 'GroupActionBar' },
        { path: '/settings', component: 'SettingsActionBar' },
        { path: '/rounds', component: 'RoundActionBar' }
    ]
});

const actionButtonReducer = (state = initialState(), action) => {
    switch (action.type) {
        case 'ADD_ACTION_BAR':
            return update(state, { routes: { $push: [action.payload] } });
        default:
            return state;
    }
};

export default actionButtonReducer;
